module.exports = __webpack_public_path__ + "img/slide-3-mob.f92cf50.webp";